import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedPrice, { PRICE_CONTEXT_PAYMENT_CTA } from '../FormattedPrice';
import { checkoutMessages } from './index';

export const PaymentCTA = ({ orderTotal, ctaLabel }) => {
  if (orderTotal === 0) {
    return <FormattedMessage {...checkoutMessages.completeOrder} />;
  }

  if (ctaLabel) {
    return (
      <>
        {ctaLabel}: <FormattedPrice value={orderTotal} context={PRICE_CONTEXT_PAYMENT_CTA} />
      </>
    );
  }

  return (
    <FormattedMessage
      {...checkoutMessages.payNow}
      values={{ price: <FormattedPrice value={orderTotal} context={PRICE_CONTEXT_PAYMENT_CTA} /> }}
    />
  );
};

PaymentCTA.propTypes = {
  orderTotal: PropTypes.number,
  couponApplied: PropTypes.bool,
  ctaLabel: PropTypes.string,
};
